import { Col, DatePicker, Form, Input, InputNumber, Radio, Row } from 'antd'
import React from 'react'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'
import PhoneInput from 'react-phone-number-input'
import ZipCodeSearchField from '../../Public/Appointment/ZipCodeSearchField'
const { RangePicker } = DatePicker

export default function AppointmentCreationForm ({ form, onFinish, rangeDisable }) {
  const onDateChange = (value) => {
    if (value[0].isSame(value[1])) {
      form.setFieldsValue({ range: [value[0], value[1].add(1, 'hour')] })
    }
    form.setFieldsValue({ appointment_date: value[0] })
  }

  return (
    <Form
      id="AppointmentFormAdmin"
      size='small'
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
    >

      <Form.Item name="type"
        rules={[{ required: true, message: t('rules.required') }]}
      >
        <Radio.Group>
          <Radio value='PatientAppointment'>{t('Admin.AppointmentForm.type.PatientAppointment')}</Radio>
          <Radio value='MaintenanceAppointment'>{t('Admin.AppointmentForm.type.MaintenanceAppointment')}</Radio>
          <Radio value='CleaningAppointment'>{t('Admin.AppointmentForm.type.CleaningAppointment')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Row gutter={16}>
        <Col>
          <Form.Item name="created_at" label={t('Admin.AppointmentForm.created_at')}>
            <DatePicker disabled={true} format={'DD/MM/YY HH[h]mm'} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="range" label={t('Admin.AppointmentForm.range')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <RangePicker
              onChange={onDateChange}
              showTime={{ format: 'HH[h]mm' }}
              format={'DD/MM/YY HH[h]mm'}
              disabled={rangeDisable} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="appointment_date" label={t('Admin.AppointmentForm.appointment_date')} >
            <DatePicker
              format={'DD/MM/YY HH[h]mm'}
              disabled />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="first_name" label={t('Admin.AppointmentForm.first_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="last_name" label={t('Admin.AppointmentForm.last_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="age" label={t('Admin.AppointmentForm.age')}
            extra={t('Admin.AppointmentForm.age_extra')} >
            <InputNumber min={0} max={150} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col style={{ maxWidth: '25%' }}>
          <Form.Item name="phone" label={t('Admin.AppointmentForm.phone')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <PhoneInput className='ant-input css-dev-only-do-not-override-xfszwz'
              international defaultCountry={'FR'}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="email" label={t('Admin.AppointmentForm.email')}>
            <Input />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="postal_place_id" label={t('Admin.AppointmentForm.zip_code')}>
            <ZipCodeSearchField form={form} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="comment" label={t('Admin.AppointmentForm.comment')}>
        <TextArea rows={5} />
      </Form.Item>
      <Form.Item name="is_now">
        <Input type='hidden' />
      </Form.Item>
    </Form>
  )
}
